import News from "AWFNews/Data/Entities/News";

export default class RecentNewsViewModel {
    public id: string;
    public headline: string;
    public headlineThumb: string;
    public intro: string;
    public dateFormatted: string;

    public constructor(news: News) {
        this.id = news.id;
        this.headline = news.headline;
        this.headlineThumb = news.headlineThumb;
        this.intro = news.intro;
        this.dateFormatted = kendo.toString(news.newsTimeStamp, 'dd/MM/yyyy');
    }
}